import { render, staticRenderFns } from "./writemail.vue?vue&type=template&id=60d83104"
import script from "./writemail.vue?vue&type=script&lang=js"
export * from "./writemail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports